(function () {
  // Mapeo de respuestas → pesos para scoring de productos.
  // Cada respuesta puntúa contra tags, palabras clave en el handle/título,
  // y rangos de precio. El producto con mayor score gana.
  var ANSWER_WEIGHTS = {
    // Q1: ¿Cómo sueles usar el aceite?
    'q1-a': { // Cocinar todo tipo de platos → formato grande
      tags: { '5L': 4, '3L': 4, '2L': 3, '1L': 2, '2.5L': 3, '5L_1L': 2, '3L_1L': 2 },
      keywords: { 'garrafa': 3, 'lata': 2, 'bag in box': 3, 'bag-in-box': 3 }
    },
    'q1-b': { // Crudo para ensaladas → 500ml monovarietal
      tags: { '500 ml': 4, '500_250': 2, '500_250_125': 2, '500_250_100': 2, '250 ml': 2 },
      keywords: { '500ml': 3 }
    },
    'q1-c': { // Regalar → packs y estuches
      tags: { 'EMporium': 4 },
      keywords: { 'pack': 4, 'estuche': 4, 'mix': 3, 'edicion': 2, 'edición': 2, 'premiados': 3, 'limitada': 3 }
    },

    // Q2: Intensidad de sabor
    'q2-a': { // Suave
      tags: { 'Arbequina': 5, 'Arbosana': 4 }
    },
    'q2-b': { // Medio/equilibrado
      tags: { 'Hojiblanca': 4, 'coupage': 4 },
      keywords: { 'coupage': 3, 'blend': 3 }
    },
    'q2-c': { // Intenso
      tags: { 'Picual': 5, 'Picudo': 4, 'Pajarera': 4 },
      keywords: { 'picual': 3, 'sin filtrar': 3, 'sin-filtrar': 3, 'picudo': 3, 'pajarer': 3 }
    },

    // Q3: ¿Te dejas llevar por el precio?
    'q3-a': { // Económico
      priceMax: 13,
      priceBonus: 5
    },
    'q3-b': { // Equilibrio calidad-precio
      priceMin: 12,
      priceMax: 20,
      priceBonus: 5
    },
    'q3-c': { // Calidad sin importar precio
      priceMin: 18,
      priceBonus: 5
    },

    // Q4: ¿Probar variedades diferentes?
    'q4-a': { // Clásico y versátil
      tags: { 'Hojiblanca': 3, 'Picual': 3, 'coupage': 3 }
    },
    'q4-b': { // Nuevos sin arriesgar
      tags: { 'Arbequina': 3, 'Arbosana': 3 },
      keywords: { 'blend': 2, 'coupage': 2 }
    },
    'q4-c': { // Únicos con carácter
      tags: { 'Pajarera': 4, 'Picudo': 4 },
      keywords: { 'ecologico': 3, 'ecológico': 3, 'sin filtrar': 3, 'sin-filtrar': 3, 'reserva': 2, 'premium': 2 }
    }
  };

  var MOBILE_MQ = '(max-width: 600px)';
  function getTopN() {
    return (window.matchMedia && window.matchMedia(MOBILE_MQ).matches) ? 4 : 5;
  }

  function scoreProduct(product, answers) {
    var score = 0;
    var titleLower = (product.title || '').toLowerCase();
    var handleLower = (product.handle || '').toLowerCase();
    var tagsLower = (product.tags || []).map(function (t) { return t.toLowerCase(); });
    var rawTags = product.tags || [];
    var price = (typeof product.price_cents === 'number' ? product.price_cents : parseFloat(product.price_cents) || 0) / 100;

    answers.forEach(function (answerId) {
      var w = ANSWER_WEIGHTS[answerId];
      if (!w) return;

      // Tags (exact match, case-sensitive against raw + case-insensitive fallback)
      if (w.tags) {
        Object.keys(w.tags).forEach(function (tag) {
          if (rawTags.indexOf(tag) !== -1 || tagsLower.indexOf(tag.toLowerCase()) !== -1) {
            score += w.tags[tag];
          }
        });
      }

      // Keywords (substring in title or handle)
      if (w.keywords) {
        Object.keys(w.keywords).forEach(function (kw) {
          var kwLower = kw.toLowerCase();
          if (titleLower.indexOf(kwLower) !== -1 || handleLower.indexOf(kwLower) !== -1) {
            score += w.keywords[kw];
          }
        });
      }

      // Price range
      if (typeof w.priceBonus === 'number') {
        var inRange = true;
        if (typeof w.priceMin === 'number' && price < w.priceMin) inRange = false;
        if (typeof w.priceMax === 'number' && price > w.priceMax) inRange = false;
        if (inRange && price > 0) score += w.priceBonus;
      }
    });

    return score;
  }

  function initQuiz(root) {
    var modal = root.querySelector('[data-quiz-modal]');
    var openBtn = root.querySelector('[data-quiz-open]');
    if (!modal || !openBtn) return;

    var closeEls = modal.querySelectorAll('[data-quiz-close]');
    var steps = Array.prototype.slice.call(modal.querySelectorAll('[data-quiz-step]'));
    var resetBtns = modal.querySelectorAll('[data-quiz-reset]');
    var dataEl = modal.querySelector('[data-quiz-products]');
    var forcedEl = modal.querySelector('[data-quiz-forced]');
    var resultsGrid = modal.querySelector('[data-quiz-results-grid]');

    var products = [];
    if (dataEl) {
      try { products = JSON.parse(dataEl.textContent); } catch (e) { products = []; }
    }

    // Mapa option_id → [handles forzados] configurado por el merchant
    var forcedMap = {};
    if (forcedEl) {
      try { forcedMap = JSON.parse(forcedEl.textContent) || {}; } catch (e) { forcedMap = {}; }
    }

    var FORCE_BONUS = 1000;

    var state = {
      stepIndex: 0,
      answers: {} // { 0: 'q1-a', 1: 'q2-b', ... }
    };

    function showStep(index) {
      state.stepIndex = index;
      steps.forEach(function (s, i) {
        s.hidden = i !== index;
      });
      var dialog = modal.querySelector('.aceites-quiz-modal__dialog');
      if (dialog) dialog.scrollTop = 0;
    }

    function selectOption(stepEl, optionId) {
      var stepIndex = parseInt(stepEl.dataset.quizStep, 10);
      state.answers[stepIndex] = optionId;
      // Visual selected state
      stepEl.querySelectorAll('[data-quiz-option]').forEach(function (opt) {
        opt.classList.toggle('is-selected', opt.dataset.quizOption === optionId);
      });
      // Enable next button
      var nextBtn = stepEl.querySelector('[data-quiz-next], [data-quiz-finish]');
      if (nextBtn) nextBtn.disabled = false;
    }

    function bindStep(stepEl) {
      var stepIndex = parseInt(stepEl.dataset.quizStep, 10);
      stepEl.querySelectorAll('[data-quiz-option]').forEach(function (opt) {
        opt.addEventListener('click', function () {
          selectOption(stepEl, opt.dataset.quizOption);
        });
      });
      var prevBtn = stepEl.querySelector('[data-quiz-prev]');
      if (prevBtn) prevBtn.addEventListener('click', function () {
        if (stepIndex > 0) showStep(stepIndex - 1);
      });
      var nextBtn = stepEl.querySelector('[data-quiz-next]');
      if (nextBtn) nextBtn.addEventListener('click', function () {
        if (state.answers[stepIndex]) showStep(stepIndex + 1);
      });
      var finishBtn = stepEl.querySelector('[data-quiz-finish]');
      if (finishBtn) finishBtn.addEventListener('click', function () {
        if (state.answers[stepIndex]) showLoadingThenResults();
      });
    }

    var LOADING_MESSAGES = [
      'Analizando tus preferencias',
      'Comparando intensidades',
      'Cruzando variedades de aceituna',
      'Seleccionando los mejores AOVE para ti'
    ];
    var loadingTimer = null;
    var loadingInterval = null;
    var LOADING_DURATION = 2400;

    function showLoadingThenResults() {
      // Mostrar el step de loading (índice = steps.length - 2, el penúltimo)
      var loadingIdx = steps.length - 2;
      showStep(loadingIdx);

      // Rotar mensajes
      var subEl = modal.querySelector('[data-quiz-loading-sub]');
      var i = 0;
      if (subEl) subEl.textContent = LOADING_MESSAGES[0];
      clearInterval(loadingInterval);
      loadingInterval = setInterval(function () {
        i = (i + 1) % LOADING_MESSAGES.length;
        if (subEl) {
          subEl.style.opacity = '0';
          setTimeout(function () {
            subEl.textContent = LOADING_MESSAGES[i];
            subEl.style.opacity = '0.7';
          }, 180);
        }
      }, 600);

      clearTimeout(loadingTimer);
      loadingTimer = setTimeout(function () {
        clearInterval(loadingInterval);
        loadingInterval = null;
        computeAndShowResults();
      }, LOADING_DURATION);
    }

    function computeAndShowResults() {
      var answers = Object.keys(state.answers)
        .sort(function (a, b) { return a - b; })
        .map(function (k) { return state.answers[k]; });

      // Cuántas veces cada handle aparece como "forzado" según las respuestas
      var forcedCounts = {};
      answers.forEach(function (answerId) {
        var arr = forcedMap[answerId];
        if (!arr) return;
        arr.forEach(function (handle) {
          forcedCounts[handle] = (forcedCounts[handle] || 0) + 1;
        });
      });

      // Score con desempate estable por orden original
      var scored = products.map(function (p, idx) {
        var score = scoreProduct(p, answers);
        if (forcedCounts[p.handle]) {
          score += FORCE_BONUS * forcedCounts[p.handle];
        }
        return { handle: p.handle, score: score, origIdx: idx };
      });

      scored.sort(function (a, b) {
        if (b.score !== a.score) return b.score - a.score;
        return a.origIdx - b.origIdx;
      });

      // SIEMPRE devolvemos TOP_N — aunque el score sea 0, mostramos los primeros
      var topHandles = scored.slice(0, getTopN()).map(function (s) { return s.handle; });

      if (resultsGrid) {
        resultsGrid.querySelectorAll('[data-product-handle]').forEach(function (card) {
          var handle = card.dataset.productHandle;
          var idx = topHandles.indexOf(handle);
          if (idx !== -1) {
            card.classList.add('is-recommended');
            card.style.order = String(idx);
          } else {
            card.classList.remove('is-recommended');
            card.style.order = '';
          }
        });
      }

      // Avanzar al paso de resultados (último step)
      showStep(steps.length - 1);
    }

    function reset() {
      clearTimeout(loadingTimer);
      clearInterval(loadingInterval);
      state.stepIndex = 0;
      state.answers = {};
      modal.querySelectorAll('[data-quiz-option]').forEach(function (opt) {
        opt.classList.remove('is-selected');
      });
      modal.querySelectorAll('[data-quiz-next], [data-quiz-finish]').forEach(function (b) {
        b.disabled = true;
      });
      if (resultsGrid) {
        resultsGrid.querySelectorAll('[data-product-handle]').forEach(function (card) {
          card.classList.remove('is-recommended');
          card.style.order = '';
        });
      }
      showStep(0);
    }

    function open() {
      reset();
      modal.hidden = false;
      document.body.classList.add('has-quiz-open');
      var firstClose = modal.querySelector('.aceites-quiz-modal__close');
      if (firstClose) firstClose.focus();
    }

    function close() {
      modal.hidden = true;
      document.body.classList.remove('has-quiz-open');
      openBtn.focus();
    }

    // Bindings
    openBtn.addEventListener('click', open);
    closeEls.forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (!modal.hidden && e.key === 'Escape') close();
    });
    steps.forEach(bindStep);
    resetBtns.forEach(function (b) { b.addEventListener('click', reset); });
  }

  document.querySelectorAll('[data-quiz-banner]').forEach(initQuiz);
})();
